import './MimeIcon.css';

import React from 'react';
import { Image, Description, VideoLibrary, Audiotrack, InsertDriveFile } from '@mui/icons-material';
import IconWithTooltip from '../../../b2b-common/IconWithTooltip';
import { Tooltip } from '@mui/material';

const getIconByMime = (mime) => {
    switch (mime) {
        case 'image/jpeg':
        case 'image/png':
        case 'image/gif':
            return { icon: <Image />, text: 'Image' };
        case 'application/pdf':
            return { icon: <Description />, text: 'PDF' };
        case 'application/msword':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            return { icon: <Description />, text: 'Word' };
        case 'video/mp4':
        case 'video/mpeg':
            return { icon: <VideoLibrary />, text: 'Video' };
        case 'audio/mpeg':
        case 'audio/wav':
            return { icon: <Audiotrack />, text: 'Audio' };
        default:
            return { icon: <InsertDriveFile />, text: 'File' };
    }
};

const MimeIcon = ({ mime }) => {
    const { icon, text } = getIconByMime(mime);
    return (
        <div className="mime-icon-with-text">
            <div className="mime-icon">
                <Tooltip title={mime}>
                    {icon}
                </Tooltip>
            </div>
            <div className='mime-text'>{text}</div>
        </div>
    );
};

export default MimeIcon;